import * as React from 'react';
import { Header2, Header3 } from '@cian/ui-kit';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { useDeviceCondition } from '../../../../hooks';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../selectors/analytics';
import {
  selectActivePackageServiceId,
  selectIsPackagesAvailable,
  selectIsPackagesVisible,
} from '../../../../selectors/publishTerms';
import { AnimationElement } from '../../../common/Animation';
import { ElementInViewport } from '../../../common/ElementInViewport';

import { trackPublicationWrapperShow } from './tracking';
import * as styles from './PublicationWrapper.css';
import { HighDemandBannerContainer } from '../../containers/HighDemandBanner';

interface IPublicationWrapperProps {
  children: React.ReactNode;
}

export const PublicationWrapper = ({ children }: IPublicationWrapperProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);
  const Header = useDeviceCondition(Header2, Header3);

  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const isPackagesAvailable = useSelector(selectIsPackagesAvailable);
  const isPackagesVisible = useSelector(selectIsPackagesVisible);
  const activePackageServiceId = useSelector(selectActivePackageServiceId);

  const handlePublicationWrapperVisible = React.useCallback(() => {
    trackPublicationWrapperShow({
      analyticsOfferStatus,
      analyticsProduct,
      isPackagesAvailable,
      isPackagesVisible,
      activePackageServiceId,
    });
  }, [isPackagesAvailable, isPackagesVisible]);

  return (
    <ElementInViewport threshold={0.25} onVisible={handlePublicationWrapperVisible}>
      <AnimationElement layout="position" className={classNames(rootStyle, styles['wrapper'])}>
        <HighDemandBannerContainer />
        <AnimationElement layout="position" className={styles['title']}>
          <Header>Публикация объявления</Header>
        </AnimationElement>

        <AnimationElement layout="position">{children}</AnimationElement>
      </AnimationElement>
    </ElementInViewport>
  );
};
